
<script setup>

  import { ref } from 'vue';

  import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';

  import { XCircleIcon } from '@heroicons/vue/24/outline';

  defineOptions( { inheritAttrs: false } );

  const props = defineProps( { title: String } );

  const isOpen = ref( false );

  function open() {
    
    isOpen.value = true;

  }

  function close() {
    
    isOpen.value = false;

  }

  defineExpose( { open, close } );

</script>

<template>

  <TransitionRoot appear :show="isOpen" as="template">

    <Dialog as="div" @close="close" class="fixed inset-0 overflow-hidden z-20">

      <div class="fixed inset-0 overflow-y-auto">

        <div class="flex min-h-full items-center justify-center p-6 drop-shadow-[0_0_15px_rgba(0,0,0,1)]">

          <TransitionChild

            as="template"

            enter="transition transform duration-300 ease-out"

            enter-from="opacity-0 scale-95"

            enter-to="opacity-100 scale-100"

            leave="transition transform duration-200 ease-in"

            leave-from="opacity-100 scale-100"

            leave-to="opacity-0 scale-95">

            <DialogPanel class="flex flex-col p-6 md:p-12 gap-4 md:gap-6 w-full bg-white" v-bind="$attrs">
              
              <div class="flex items-center justify-between gap-5">

                <DialogTitle as="h3" class="text-2xl md:text-4xl font-heading uppercase" v-html="title" />

                <button type="button" @click="close" class="group flex items-center gap-2">

                  <div class="text-sm group-focus-visible:underline group-hover:underline">Close</div>

                  <XCircleIcon class="w-8" />
                
                </button>

              </div>

              <div>

                <slot />

              </div>

            </DialogPanel>

          </TransitionChild>

        </div>

      </div>

    </Dialog>

  </TransitionRoot>

  <slot name="button" :open="open" :close="close" />

</template>
